import a from 'axios';
import qs from 'qs';
import { V } from './variable.js';
import { G } from './index.js';
import {
  updateSmTokenByClient,
  executeProtocol,
  getRequestUrl,
  isInHeybox,
  showMessage,
} from '../utils';
// import { HbToast } from '@heybox-components/heybox-ui'
import m from 'js-md5';
const authens = [
  'need_alipay_verify',
  'need_phone_code',
  'need_bind_phone',
  'name_verify',
];
const REPORT_SM_DEVICE_ID_APIS = [
  '/account/open/login',
  '/account/open/get_login_code',
  '/account/open/login_with_code',
];

var show_caputure_promise = null;
async function showCaptcha(res) {
  const callback = (clear) => (data) => {
    if (clear) {
      show_caputure_promise = null
    }
    const newConfig = {
      ...res.config,
      params: {
        ...res.config.params,
        ...data,
      },
    };
    return A(newConfig)
  }
  if (show_caputure_promise) {
    return show_caputure_promise.then(callback(false)) 
  } else {
    show_caputure_promise = new Promise((resolve, reject) => {
      const captcha = new window.TencentCaptcha('2061805035', (q_res) => {
        if (q_res.ret == 0) {
          resolve({
            ticket: q_res.ticket,
            randstr: q_res.randstr,
            captcha_type: "confirm",
          })
        } else {
          reject()
        }
      });
      captcha.show();
    })
    return show_caputure_promise.then(callback(true)) 
  }
}
function loadScriptOnce(src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      return resolve();
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = (err) => reject(err);
    document.body.appendChild(script);
  });
}
const A = a.create();
A.create = a.create;
// POST传参序列化(添加请求拦截器)
A.interceptors[`${V[11]}${V[2]}${V[10]}${V[14]}${V[2]}${V[12]}${V[13]}`].use(
  async (config) => {
    // 在发送请求之前做某件事

    let p = {
      ...config.params,
    };
    // 时间戳
    let t = ~~(+G.w() / 1000);

    // nonce生成
    let n = m(
      t + Math.random(new Date().getTime()).toString(),
    ).toLocaleUpperCase();
    // hkey
    p[`${V[4]}k${V[2]}y`] = G[V[3]](
      getRequestUrl(
        config[`${V[14]}${V[11]}l`].replace('/chatroom_xiaoheihe', ''),
        false,
      ),
      t,
      n,
    );

    // _time
    p[`_${V[13]}${V[5]}${V[6]}${V[2]}`] = t;

    // nonce
    p[`${V[7]}${V[8]}${V[7]}c${V[2]}`] = n;
    config.params = p;

    if (config.method === `${V[9]}${V[8]}${V[12]}${V[13]}`) {
      if (!config.upload) {
        config.data = {
          ...config.data,
        };
        config.data = qs.stringify(config.data, { indices: false });
      }
    }
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error.message);
  },
);

A.interceptors[
  `${V[11]}${V[2]}${V[12]}${V[9]}${V[8]}${V[7]}${V[12]}${V[2]}`
].use((res) => {
  let status_key = res.data.status;
  if (authens.indexOf(status_key) >= 0) {
    executeProtocol({
      protocol_type: 'openAuthentication',
      type: status_key,
    });
  } else if (status_key == 'lack_token') {
    if (isInHeybox()) {
      updateSmTokenByClient().finally(() => {
        showMessage('failed', '请稍后刷新重试');
      });
    } else {
      window.dealSmDeviceId(() => {
        // HbToast.error('请稍后刷新重试')
      });
    }
  } else if (status_key == 'show_captcha') {
    return loadScriptOnce("https://turing.captcha.qcloud.com/TCaptcha.js").then(() => {
      return showCaptcha(res);
    })
  } else if (!res.config.params['_notip'] && status_key != 'ok' && res.data[['m', 's', 'g'].join('')]) {
    if (res.data.msg.indexOf('数据上报失败') == -1) {
      showMessage('failed', res.data.msg);
    }
  }
  return res;
});

A.all = a.all;
export default A;
